<template>
  <div class="echarts">
    <div :style="{height:'600px',width:'900px',border:'1px solid red'}" ref="myEchart"></div>
  </div>
</template>
<script>
  import echarts from "echarts";
  import '../../../node_modules/echarts/map/js/world.js'// 引入世界地图数据
//   import '../../../node_modules/echarts/map/js/china.js' // 引入中国地图数据
export default {
    name: "echarts",
    data() {
      return {
          
        clickName: '',
        mapData: [  
            {'latitude':23.944082, 'longitude':121.103108, 'name':'1', 'value':66, 'color':'#0394d9'},
            {'latitude':35.813131, 'longitude':139.687913, 'name':'2', 'value':16666, 'color':'#ff0000'},
        ],
        arr:[{'name':'Thailand',value:[100.483741,13.743748,10],},{name:'Australia',value:[133.479629,-24.922317]}],
        countryArr: [  
            {name: 'Afghanistan', value: 10},  
            {name: 'Angola', value: 1},  
            {name: 'Albania', value: 1},  
            {name: 'United Arab Emirates', value: 10},  
            {name: 'Argentina', value: 1},  
            {name: 'Armenia', value: 1},  
            {name: 'French Southern and Antarctic Lands', value: 1},  
            {name: 'Australia', value: 1},  
            {name: 'Austria', value: 1},  
            {name: 'Azerbaijan', value:1},  
            {name: 'Burundi', value: 1},  
            {name: 'Belgium', value: 1},  
            {name: 'Benin', value:1},  
            {name: 'Burkina Faso', value: 1},  
            {name: 'Bangladesh', value: 1},  
            {name: 'Bulgaria', value: 1},  
            {name: 'The Bahamas', value: 1},  
            {name: 'Bosnia and Herzegovina', value: 10},  
            {name: 'Belarus', value: 10},  
            {name: 'Belize', value: 1},  
            {name: 'Bermuda', value:1},  
            {name: 'Bolivia', value: 1},  
            {name: 'Brazil', value: 1},  
            {name: 'Brunei', value: 1},  
            {name: 'Bhutan', value: 10},  
            {name: 'Botswana', value: 19},  
            {name: 'Central African Republic', value: 43},  
            {name: 'Canada', value: 34},  
            {name: 'Switzerland', value: 78},  
            {name: 'Chile', value: 17},  
            {name: 'China', value: 10},  
            {name: 'Ivory Coast', value: 1},  
            {name: 'Cameroon', value: 206},  
            {name: 'Democratic Republic of the Congo', value: 621},  
            {name: 'Republic of the Congo', value: 35},  
            {name: 'Colombia', value: 464},  
            {name: 'Costa Rica', value: 46},  
            {name: 'Cuba', value: 112},  
            {name: 'Northern Cyprus', value:1},  
            {name: 'Cyprus', value: 11},  
            {name: 'Czech Republic', value: 105},  
            {name: 'Germany', value: 830},  
            {name: 'Djibouti', value: 8},  
            {name: 'Denmark', value: 55},  
            {name: 'Dominican Republic', value: 100},  
            {name: 'Algeria', value: 37},  
            {name: 'Ecuador', value: 150},  
            {name: 'Egypt', value: 780},  
            {name: 'Eritrea', value: 57},  
            {name: 'Spain', value: 461},  
            {name: 'Estonia', value: 12},  
            {name: 'Ethiopia', value: 870},  
            {name: 'Finland', value: 53},  
            {name: 'Fiji', value: 8},  
            {name: 'Falkland Islands', value: 1},  
            {name: 'France', value: 632},  
            {name: 'Gabon', value: 15},  
            {name: 'United Kingdom', value: 62},  
            {name: 'Georgia', value: 43},  
            {name: 'Ghana', value: 242},  
            {name: 'Guinea', value: 108},  
            {name: 'Gambia', value: 1},  
            {name: 'Guinea Bissau', value: 108},  
            {name: 'Equatorial Guinea', value: 6},  
            {name: 'Greece', value: 111},  
            {name: 'Greenland', value: 10},  
            {name: 'Guatemala', value: 143},  
            {name: 'French Guiana', value: 1},  
            {name: 'Guyana', value: 7},  
            {name: 'Honduras', value: 76},  
            {name: 'Croatia', value: 43},  
            {name: 'Haiti', value: 10},  
            {name: 'Hungary', value: 100},  
            {name: 'Indonesia', value: 2406},  
            {name: 'India', value: 12056},  
            {name: 'Ireland', value: 44},  
            {name: 'Iran', value: 2406},  
            {name: 'Iraq', value: 30},  
            {name: 'Iceland', value: 3},  
            {name: 'Israel', value: 74},  
            {name: 'Italy', value: 605},  
            {name: 'Jamaica', value: 27},  
            {name: 'Jordan', value: 64},  
            {name: 'Japan', value: 1273},  
            {name: 'Kazakhstan', value: 159},  
            {name: 'Kenya', value: 409},  
            {name: 'Kyrgyzstan', value: 53},  
            {name: 'Cambodia', value: 143},  
            {name: 'South Korea', value: 514},  
            {name: 'Kosovo', value: 10},  
            {name: 'Kuwait', value: 2},  
            {name: 'Laos', value: 63},  
            {name: 'Lebanon', value: 43},  
            {name: 'Liberia', value: 3},  
            {name: 'Libya', value: 60},  
            {name: 'Sri Lanka', value: 207},  
            {name: 'Lesotho', value: 20},  
            {name: 'Lithuania', value: 30},  
            {name: 'Luxembourg', value: 5},  
            {name: 'Latvia', value: 20},  
            {name: 'Morocco', value: 31},  
            {name: 'Moldova', value: 1},  
            {name: 'Madagascar', value: 210},  
            {name: 'Mexico', value: 1178},  
            {name: 'Macedonia', value: 1},  
            {name: 'Mali', value: 139},  
            {name: 'Myanmar', value: 519},  
            {name: 'Montenegro', value: 1},  
            {name: 'Mongolia', value: 27},  
            {name: 'Mozambique', value: 239},  
            {name: 'Mauritania', value: 3},  
            {name: 'Malawi', value: 150},  
            {name: 'Malaysia', value: 282},  
            {name: 'Namibia', value: 21},  
            {name: 'New Caledonia', value: 2},  
            {name: 'Niger', value: 158},  
            {name: 'Nigeria', value: 159},  
            {name: 'Nicaragua', value: 58},  
            {name: 'Netherlands', value: 166},  
            {name: 'Norway', value: 48},  
            {name: 'Nepal', value: 268},  
            {name: 'New Zealand', value: 43},  
            {name: 'Oman', value: 28},  
            {name: 'Pakistan', value: 1731},  
            {name: 'Panama', value: 36},  
            {name: 'Peru', value: 29},  
            {name: 'Philippines', value: 934},  
            {name: 'Papua New Guinea', value: 68},  
            {name: 'Poland', value: 381},  
            {name: 'Puerto Rico', value: 37},  
            {name: 'North Korea', value:1},  
            {name: 'Portugal', value: 105},  
            {name: 'Paraguay', value: 64},  
            {name: 'Qatar', value: 17},  
            {name: 'Romania', value: 218},  
            {name: 'Russia', value: 218},  
            {name: 'Rwanda', value: 108},  
            {name: 'Western Sahara', value: 5},  
            {name: 'Saudi Arabia', value: 272},  
            {name: 'Sudan', value: 356},  
            {name: 'South Sudan', value: 99},  
            {name: 'Senegal', value: 129},  
            {name: 'Solomon Islands', value: 5},  
            {name: 'Sierra Leone', value: 57},  
            {name: 'El Salvador', value: 62},  
            {name: 'Somaliland', value: 96},  
            {name: 'Somalia', value: 96},  
            {name: 'Republic of Serbia', value: 35},  
            {name: 'Suriname', value: 1},  
            {name: 'Slovakia', value: 54},  
            {name: 'Slovenia', value: 20},  
            {name: 'Sweden', value: 93},  
            {name: 'Swaziland', value: 11},  
            {name: 'Syria', value: 78},  
            {name: 'Chad', value: 117},  
            {name: 'Togo', value: 63},  
            {name: 'Thailand', value: 664},  
            {name: 'Tajikistan', value: 76},  
            {name: 'Turkmenistan', value: 50},  
            {name: 'East Timor', value: 100},  
            {name: 'Trinidad and Tobago', value: 13},  
            {name: 'Tunisia', value: 10},  
            {name: 'Turkey', value: 721},  
            {name: 'United Republic of Tanzania', value: 44},  
            {name: 'Uganda', value: 339},  
            {name: 'Ukraine', value: 46},  
            {name: 'Uruguay', value: 33},  
            {name: 'United States of America', value: 3122},  
            {name: 'Uzbekistan', value: 27},  
            {name: 'Venezuela', value: 2},  
            {name: 'Vietnam', value: 890},  
            {name: 'Vanuatu', value: 1},  
            {name: 'West Bank', value: 1},  
            {name: 'Yemen', value: 227},  
            {name: 'South Africa', value: 514},  
            {name: 'Zambia', value: 132},  
            {name: 'Zimbabwe', value: 10}  
        ],
      }
    },
    // name": "厦门", "value": [ 118.0875168, 24.45743561, 10 ] }
    mounted() {
      this.chinaConfigure();
    },
    methods: {
        
        chinaConfigure() {
            let myChart = echarts.init(this.$refs.myEchart); //这里是为了获得容器所在位置    
            window.onresize = myChart.resize;
            myChart.setOption({
                title: {  
                    sublink: 'http://esa.un.org/wpp/Excel-Data/population.htm',  
                    left: 'center',  
                    top: 'top'  
                },  
          
                visualMap: {  
                    // text:['High','Low'],  
                    // realtime: false,  
                    // calculable: true,  
                    min: 0,//最小
                    max: 10,//最大
                    splitNumber: 2,//共分2层
                    color: ['#f1c621','#c9c9c9'],//颜色从高到低依次渐变
                    splitList: [   
                        {start: 0, end: 5},
                        {start: 6, end: 10},  
                    ],  
                    color: ['orangered','lightskyblue'],  
                },  
                 //地图区域样式
                geo:{
                    map: 'world',
                    silent: true,//鼠标hover 不高亮显示区块
                    label: {
                        emphasis: {//省份名字消除
                            show: false
                        },
                    },
                    itemStyle: {
                        //未激活样式
                        normal: {
                            // areaColor: '#b7b7b7',
                            borderColor: '#fff',
                            borderWidth: 2,
                        },
                        //激活样式
                        emphasis: {
                            show:false
                        }
                    }
                },
                series: [  
                    {  
                        name: 'World Population (2010)',  
                        type: 'map',  
                        mapType: 'world',  
                        coordinateSystem: 'geo',//关联上面的geo
                        geoIndex: 0,//两个地图合在一起
                        silent: true,//鼠标hover 不高亮显示区块
                        roam: true,  
                        itemStyle:{  
                            emphasis:{label:{show:true}}  
                        },  
                        data: this.countryArr,
                    },
                    {
                        name: '直营',
                        type: 'scatter',
                        coordinateSystem: 'geo',
                        data: this.arr,// this.convertData(this.getCoorMapCity),
                        symbolSize: [40,25],
                        symbol:'image:////www.baidu.com/img/baidu_resultlogo@2.png',
                        label: {
                            show:true,  
                            normal: {
                                show: true,
                                formatter:'{b}',
                                position: 'top',
                                offset:[15,15],//文字的相对偏移
                                padding:[5,10,5,10],
                                backgroundColor: '#f28d00',
                                borderRadius: 20,
                                color: '#fff',
                                fontSize: 10,
                                // pos: '{c}',
                            },
                            emphasis: {
                                show: false
                            },
                        },
                        //标签的样式
                        itemStyle: {
                            emphasis: {
                                borderColor: '#fff',
                                borderWidth: 1,
                            }
                        }
                    },
                    // {
                    //     type: 'scatter',
                    //     coordinateSystem: 'geo',
                    //     data: this.mapData.map(function (itemOpt) {
                    //                     return {
                    //                         name: itemOpt.name,
                    //                         symbol:'image:////www.baidu.com/img/baidu_resultlogo@2.png',
                    //                         symbolSize: [40,25],
                    //                         value: [
                    //                             itemOpt.longitude,
                    //                             itemOpt.latitude,
                    //                             itemOpt.value
                    //                         ],

                    //                         label: {
                    //                             emphasis: {
                    //                                 position: 'right',
                    //                                 show: false
                    //                             }
                    //                         },
                    //                         itemStyle: {
                    //                             normal: {
                    //                                 color: itemOpt.color
                    //                             }
                    //                         }
                    //                     };
                    //             }),
                    //     // label: {
                    //     //     show:true,  
                    //     //     normal: {
                    //     //         show: true,
                    //     //         formatter:'{b}',
                    //     //         position: 'top',
                    //     //         offset:[15,15],//文字的相对偏移
                    //     //         padding:[5,10,5,10],
                    //     //         backgroundColor: '#f28d00',
                    //     //         borderRadius: 20,
                    //     //         color: '#fff',
                    //     //         fontSize: 10,
                    //     //         // pos: '{c}',
                    //     //     },
                    //     //     emphasis: {
                    //     //         show: false
                    //     //     },
                    //     // },
                    //     // //标签的样式
                    //     // itemStyle: {
                    //     //     emphasis: {
                    //     //         borderColor: '#fff',
                    //     //         borderWidth: 1,
                    //     //     }
                    //     // }
                    // },  
                ]  
            })
       }
    },
}
</script>